import { GET_SUBSCRIPTION } from 'actions/subscription';

const initialState = {
  isLoading: false,
  subscriptions: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const subscriptionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_SUBSCRIPTION.REQUEST: {
      return { ...state, isLoading: true };
    }
    case GET_SUBSCRIPTION.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        subscriptions: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }
    case GET_SUBSCRIPTION.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default subscriptionReducer;
